import gql from 'graphql-tag';
import {useMutation} from '@apollo/client';
import BulkRmiRequest from "../../types/BulkRmiRequest";
import Address from "../../types/address";

const MUTATION = gql`
  mutation createBulkRmiRequest($input: BulkRmiInput!) {
    createBulkRmiRequest(input: $input) {
      statusCode
      message
      bulkRmiRequest {
        id
      }
    }
  }
`;

export interface BulkRmiContact {
  name: string;
  email: string;
}

export interface BulkRmiInput {
  companyAddress: Address;
  vendorCode: string;
  contact: BulkRmiContact;
  packageOptions: string[];
  productListDescription: string;
  isRenewal?: boolean;
  renewalParentRequestId?: string;
}

export interface BulkRmiResponse {
  statusCode: number;
  message: string;
  bulkRmiRequest: BulkRmiRequest
}

const useCreateBulkRmiRequest = (onCompleted = (_response: any) => {
}) => {
  const [action] = useMutation(MUTATION, { onCompleted });

  return (input: BulkRmiInput) => {
    return action({ variables: { input: input } });
  };
};

export default useCreateBulkRmiRequest;
